import dotprop from 'finboxio-dot-prop'
export const { get, set } = dotprop
export default dotprop
